// Días no laborales agregados por el usuario ("actividades oficina"), persistidos
// en localStorage. Los feriados legales vienen aparte (data/holidays-cl.ts) y no
// se editan; acá solo se guardan los días extra que marca el usuario.
//
// El botón "Reset demo" también los limpia (ver resetDemo en store.ts si se enlaza).

const STORAGE_KEY = 'fycom_dias_oficina';

// portion: cuánto de la jornada NO se trabaja ese día.
//   'completo'      → no se trabaja (meta del día = 0)
//   'media_jornada' → se trabaja la mitad (meta del día = 50%)
export type DayPortion = 'completo' | 'media_jornada';

export interface CustomNonWorkingDay {
  date: string; // YYYY-MM-DD
  name: string;
  portion: DayPortion;
}

function load(): CustomNonWorkingDay[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        // Compatibilidad: días guardados antes de existir `portion` → completo.
        return parsed.map((d) => ({ portion: 'completo' as DayPortion, ...d }));
      }
    }
  } catch {
    // corrupto → vacío
  }
  return [];
}

let days: CustomNonWorkingDay[] = load();

function persist() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(days));
  } catch {
    // sin espacio / modo privado
  }
}

export function getCustomDays(): CustomNonWorkingDay[] {
  return [...days];
}

export function addCustomDay(
  date: string,
  name: string,
  portion: DayPortion = 'completo'
): void {
  if (days.some((d) => d.date === date)) return; // ya existe
  days.push({ date, name: name.trim() || 'Actividad oficina', portion });
  persist();
}

export function removeCustomDay(date: string): void {
  days = days.filter((d) => d.date !== date);
  persist();
}

export function resetCustomDays(): void {
  days = [];
  persist();
}
